<template>
  <BasicModal
    :width="'80vw'"
    :title="getTitle()"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="-container disp-scroll" v-if="recordingInterview">
      <!-- 応募者紐付けダイアログ -->
      <ModalSeekerSearch
        :isSeekerSearchDialogOpen="isSeekerSearchDialogOpen"
        :initName="searchName"
        :initEmail="searchEmail"
        @select-seeker="selectSeeker"
        @close-seeker-search="closeSeekerSearch"
      />
      <div class="input-field">
        <div class="-menu">
          <div>
            <div class="question-title-container">
              <span>質問{{(Number(recordingInterview.recording_content[index].order) + 1)}}：</span>
              <b-select v-model="index">
                <option
                  v-for="(content, i) in recordingInterview.recording_content"
                  :key="content.id"
                  :value="i"
                >
                  {{content.name}}
                </option>
              </b-select>
            </div>
            <p style="font-size: 13px; color: #666;">各行（評価コメント以外）をクリックすると既読になります。</p>
          </div>
          <div style="text-align: right;">
            <b-dropdown aria-role="list" v-if="recordingInterview.recording_content[index].question_recording">
              <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                  <span>再生速度 × {{speedRate}}</span>
                  <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
              </button>
              <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.0)">× 1.0</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.2)">× 1.2</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.5)">× 1.5</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.7)">× 1.7</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(2.0)">× 2.0</b-dropdown-item>
            </b-dropdown>
            <b-pagination
              :total="recordingInterview.recording_content[index].recording_answer.length"
              :per-page="10"
              v-model="currentPage"
              @change="changePageModalAnswerRecord()"
              style="margin: 16px 0px;">
            </b-pagination>
          </div>
        </div>
        <div class="video-wrapper">
          <table class="table-box">
            <tr>
              <th class="table-box-header" style="max-width: 64px; width: 64px;"></th>
              <th class="table-box-header" style="max-width: 300px; width: 300px;">名前</th>
              <th class="table-box-header">回答</th>
              <th class="table-box-header">評価コメント</th>
              <th class="table-box-header">再再生の理由</th>
              <th class="table-box-header">採用フロー</th>
            </tr>
            <template v-if="answerRecord.length > 0">
              <tr
                v-for="(answer, i) in answerRecord"
                :key="i"
                @click="updateRecordingReadAnswer(answer)">
                <td style="text-align: center;">
                  <p style="color: #a22;" v-if="getUnread(answer.read_user)">未</p>
                  <p style="color: #666;" v-else>既</p>
                </td>
                <td>
                  <!-- 応募者と紐付けがある場合 -->
                  <div v-if="answer.seeker">
                    <p>
                      {{answer.seeker_data.name}}
                    </p>
                    <p style="font-size: 13px; color: #666;">
                      {{answer.seeker_data.email}}
                    </p>
                  </div>
                  <!-- 応募者と紐付けがない場合 -->
                  <div v-else>
                    <p>
                      {{answer.answer_name}}
                    </p>
                    <p style="font-size: 13px; color: #666;">
                      {{answer.answer_email}}
                    </p>
                  </div>
                  <p style="font-size: 13px; color: #666;">
                    {{new Date(answer.created_at).toLocaleString('ja-JP')}}
                  </p>
                  <!-- 応募者紐付けボタン -->
                  <b-field>
                    <button
                      class="button is-small -top-8px"
                      @click="openSeekerSearch(answer, i)"
                    >
                      応募者紐付
                    </button>
                    <p style="padding: 8px; font-size: 13px; color: #666;" v-if="answer.seeker">
                      紐付け済み
                    </p>
                  </b-field>
                </td>
                <td style="max-width: 180px; text-align: center;">
                  <RecordingVideoTag
                    v-if="answer.answer_recording"
                    :index="index + '-' + i"
                    :video="answer.answer_recording"
                    :answerRecord="answerRecord"
                  />
                  <div v-else>
                    <p>制限時間内に回答されなかったため、録画されておりません。</p>
                  </div>
                </td>
                <td @mouseover="isOverModifyArea=true" @mouseleave="isOverModifyArea=false">
                  <star-rating style="font-size: 12px; margin-top: 0; color: yellow;" :increment="0.5" v-model="answer.rate" :star-size="24" :show-rating="false"></star-rating>
                  <textarea
                    style="min-height: 88px;"
                    class="textarea disp-scroll"
                    placeholder="評価を記載"
                    maxlength="500"
                    v-model="answer.comment"
                  />
                  <button style="float: left;" class="button is-small -top-8px" @click="updateRecordingAnswer(answer)">
                    評価内容を保存
                  </button>
                  <div style="width:100px; float:left; font-size:12px; margin:8px 0 0 8px;">
                    評価最終更新者：<br>
                    <template v-if="answer.comment_user_data">
                      {{answer.comment_user_data.username}}
                    </template>
                    <template v-else>-</template>
                  </div>
                </td>
                <td>
                  <p style="color: silver; font-weight: normal;" v-if="answer.reason_replay== 'undefined'">
                    1度しか再生されておりません。
                  </p>
                  <p style="font-weight: normal;" v-else>
                    {{answer.reason_replay}}
                  </p>
                </td>
                <td>
                  <div v-if="answer.seeker">
                    <b-field>
                      <!-- 採用フロー:ステージ -->
                      <template v-if="recruitmentFlows.length > 0">
                        ステージ：
                        <select
                          class="select"
                          v-model="answer.seeker_data.recruitment_flow_stage"
                          @change="changeRecruitmentFlow(answer.seeker_data)"
                        >
                          <option v-for="(stg, keyStg) in recruitmentFlows[0].stages"
                            v-bind:value="stg.pk"
                            :key="keyStg + '-' + index +  '-' + i"
                          >
                            {{ stg.name }}
                          </option>
                        </select>
                      </template>
                    </b-field>
                    <b-field>
                      <!-- 採用フロー:ステータス -->
                      <template v-if="recruitmentFlows.length > 0">
                        ステータス：
                        <select
                          class="select"
                          v-model="answer.seeker_data.recruitment_flow_status"
                          @change="changeRecruitmentFlow(answer.seeker_data)"
                          :disabled="!getRecruitmentFlowStatus(answer.seeker_data.recruitment_flow_stage)"
                        >
                          <option v-for="(sts, keySts) in getRecruitmentFlowStatus(answer.seeker_data.recruitment_flow_stage)"
                            v-bind:value="sts.pk"
                            :key="keySts + '-' + index + '-' + i"
                          >
                            {{ sts.name }}
                          </option>
                        </select>
                      </template>
                    </b-field>
                  </div>
                  <div v-else>
                    応募者との紐付けが必要です
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="6">
                  <p>
                    回答データがございません。
                  </p>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
    </div>
    <div>
    <b-loading
      v-if="isChangePageModalAnswerRecord"
      active=true
      :is-full-page="false"
    >
      <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
    </b-loading>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button
        class="button is-primary"
        @click="changeIndex(-1)"
        :disabled="isMinIndex">
        <span class="mdi mdi-chevron-left -right-8px"></span>
        前の質問へ
      </button>
      <button
        class="button"
        @click="cancel">
        閉じる
      </button>
      <button
        class="button is-primary"
        @click="changeIndex(1)"
        :disabled="isMaxIndex">
        <span class="mdi mdi-chevron-right -right-8px"></span>
        次の質問へ
      </button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal        from '@/components/Modals/BasicModal'
import RecordingVideoTag from '@/components/VideoView/organisms/RecordingVideoTag'
import ModalSeekerSearch from '@/components/organisms/modals/ModalSeekerSearch'
import StarRating        from 'vue-star-rating'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  components: {
    BasicModal,
    RecordingVideoTag,
    ModalSeekerSearch,
    StarRating,
    ActionSet: {
      template: `
                  <div style="display: flex; justify-content: center; align-items: center; width: 230px;">
                    <template v-if="actionProp">
                      <select class="select" style="max-width: 160px; min-width: 160px;" v-model="newActionHistory" @change="openModal(newActionHistory)">
                        <option :value="act" v-for="(act, idxP) in actionProp" :key="idxP">{{act.name}}</option>
                      </select>
                    </template>
                    <template v-else>
                      <select class="select" disabled>
                        <option>-</option>
                      </select>
                    </template>
                    <a @click="changeOpenLog()" style="text-align: left; margin-left: 8px; font-size: small;">
                      <span class="mdi mdi-animation-outline" style="margin-right: 4px;"></span>履歴
                    </a>
                  </div>
                `,
      props: ['skProp', 'actionProp'],
      data () {
        return {
          newActionHistory: null,
          openLog: false
        }
      },
      methods: {
        openModal (acthis) {
          let data = {
            action: acthis,
            sk: this.skProp
          }
          this.$emit('openActionCheckModal', data)
          this.newActionHistory = null
        },
        changeOpenLog(flg) {
          if (this.skProp.recruitment_flow_action_history.length === 0) {
            alert('アクション履歴がありません。')
          } else {
            this.$emit('openActionTableModal', this.skProp)
          }
        }
      }
    }
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    recordingInterview: {
      type: Object,
      required: true
    },
    answerRecord: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    recruitmentFlows: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    isChangePageModalAnswerRecord: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    index () {
      this.speedRate = 1.0
    }
  },
  computed: {
    isMaxIndex () {
      return this.index === this.recordingInterview.recording_content.length - 1
    },
    isMinIndex () {
      return this.index === 0
    },
  },
  data () {
    return {
      video: null,
      index: 0,
      speedRate: 1.0,
      isOverModifyArea: false,
      isSeekerSearchDialogOpen: false,
      searchName: '',
      searchEmail: '',
      selectSeekerIndex: -1,
      currentPage: 1,
    }
  },
  methods: {
    changePageModalAnswerRecord() {
      this.$emit('changePageModalAnswerRecord', this.recordingInterview.recording_content[this.index], this.currentPage)
    },
    getUnread (users) {
      return !this.$_.includes(users, this.user.userHash)
    },
    getTitle () {
      if (this.recordingInterview) {
        return this.recordingInterview.name + '（質問数：' + this.recordingInterview.recording_content.length + '）'
      } else {
        return '-'
      }
    },
    cancel () {
      this.$emit('cancel', false, this.recordingInterview)
    },
    changeSpeedRate (rate) {
      this.$nextTick(() => {
        this.recordingInterview.recording_content[this.index].recording_answer.forEach((_, i) => {
          let video = document.getElementById('question-' + this.index + '-' + i)
          video.playbackRate = rate
          this.speedRate = rate
        })
      })
    },
    changeIndex (delta) {
      const res = delta + this.index
      const max = this.recordingInterview.recording_content.length - 1
      if (res < 0) {
        this.index = max
      } else if (res > max) {
        this.index = 0
      } else {
        this.index = res
      }
      this.currentPage = 1
      this.changePageModalAnswerRecord()
    },
    updateRecordingAnswer (data) {
      this.sendControlLog('録画面接　評価　保存', '録画面接回答画面にて、「評価内容を保存」ボタンをクリックした。')
      data.comment_user = this.user.userHash
      this.$emit('update-recording-answer', data)
    },
    getUserName (hash) {
      let name = '-'
      for (const user of this.users) {
        if (user.user_hash === hash) {
          name = user.username
        }
      }
      return name
    },
    updateRecordingReadAnswer (data) {
      if (this.isOverModifyArea) {
        return
      }
      this.$emit('update-recording-read-answer', data)
    },
    /** 回答紐付けダイアログ */
    openSeekerSearch (answer, index) {
      // アイテム紐付けダイアログ表示
      if (answer.seeker) {
        // 紐付けされている場合はSeekerの名前とEmail
        this.searchName  = answer.seeker_data.name
        this.searchEmail = answer.seeker_data.email
      } else {
        // 紐付けされていない場合は回答動画の名前とEmail
        this.searchName  = answer.answer_name
        this.searchEmail = answer.answer_email
      }
      // 選択された応募者の回答動画インデックス
      this.selectSeekerIndex = index
      // 応募者との紐付けダイアログを開く
      this.isSeekerSearchDialogOpen = true
    },
    closeSeekerSearch () {
      this.isSeekerSearchDialogOpen = false
    },
    /** 回答紐付け */
    selectSeeker (seeker) {
      if (this.selectSeekerIndex >= 0) {
        // 同一人物の回答動画を全て紐付ける
        const name  = this.answerRecord[this.selectSeekerIndex].answer_name
        const email = this.answerRecord[this.selectSeekerIndex].answer_email

        this.$emit('update-recording-select-seeker', {"name": name, "email": email, "seeker": seeker})
        this.$emit('update-recording-read-answer', this.answerRecord[this.selectSeekerIndex])

        // 選択されたインデックスの初期化
        this.selectSeekerIndex = -1
      }
    },
    changeRecruitmentFlow (skData) {
      this.sendControlLog('録画面接　採用フロー　変更', '録画面接回答画面にて、採用フローを変更した。')
      this.$emit('change-recruitment-flow', skData)
    },
    getRecruitmentFlowStatus (stg) {
      if (!stg || this.recruitmentFlows.length === 0) return null
      for (let re of this.recruitmentFlows[0].stages) {
        if (re.pk === stg) return re.status
      }
      return null
    },
    getRecruitmentFlowActions (sts) {
      if (!sts || this.recruitmentFlows.length === 0) return null
      for (let i in this.recruitmentFlows[0].stages) {
        for (let re of this.recruitmentFlows[0].stages[i].status) {
          if (re.pk === sts) return re.actions
        }
      }
      return null
    },
    openActionCheckModal (data) {
      this.$emit('openActionCheckModal', data)
    },
    openActionTableModal (data) {
      this.$emit('openActionTableModal', data)
    },
    openActionCheckModal (data) {
      this.$refs.actchk.sk     = data.sk
      this.$refs.actchk.action = data.action
      this.$refs.actchk.active = true
    },
    openActionTableModal (data) {
      this.$refs.acttbl.sk     = data
      this.$refs.acttbl.active = true
    },
  }
}
</script>

<style lang="scss" scoped>
.-container {
  margin: 16px;
  height: 75vh;
  position: relative;
}
.input-field {
  text-align: left;
  padding: 0 8px;
  p {
    font-weight: 600;
    margin-bottom: 8px;
  }
  .-menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    position: sticky;
    top: 0;
    z-index: 10;
    background: #fff;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 30%;
  }
}
.table-box {
  width: 100%;
  td {
    padding: 8px;
  }
}
.table-box-header {
  border: solid thin #ccc !important;
  background: rgb(250, 230, 230) !important;
  color: #222;
  padding: 8px !important;
  text-align: center;
}
.video-wrapper {
  position: relative;
  width: 100%;
  /deep/ .video-back {
    width: 100%;
    min-width: 140px;
    max-height: 160px;
  }
  .question-title {
    position: absolute;
    font-size: 32px;
    top: 0;
    left: 0;
    color: white;
    padding: 4px 8px;
  }
}
.question-title-container {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/VideoView/organisms/ModalAnswerRecord.vue